import { useLocation } from "react-router-dom";

import { ssoFailureReasonSchema } from "../../schemas";
import { decodeSsoFailure } from "../../utils";

import { LoginSsoErrorTemplate } from "./login-sso-error.template";

export const LoginSsoError = () => {
	const { hash, search } = useLocation();
	const errorParam = new URLSearchParams(hash.slice(1)).get("error");
	const ssoFailure = errorParam
		? decodeSsoFailure(errorParam)
		: {
				...decodeSsoFailure(null),
				reason: ssoFailureReasonSchema.catch("unknown").parse(new URLSearchParams(search).get("reason")),
			};
	const troubleshootUrl = ssoFailure.idToken
		? {
				pathname: "/login-sso-troubleshoot",
				hash: `#${new URLSearchParams({ idToken: ssoFailure.idToken })}`,
			}
		: null;

	return <LoginSsoErrorTemplate reason={ssoFailure.reason} troubleshootUrl={troubleshootUrl} />;
};
